import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  loading: false,
  isAuthenticated: false,
  user: null,
  error: null,
};

// Redux slice for user management
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    LoadUserRequest: (state) => {
      state.loading = true;
      console.log("🚀 ~  state.loading:",  state.loading)
    },
    LoadUserSuccess: (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    LoadUserFail: (state, action) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.user = null;
      state.error = action.payload;
    },
    LogoutUser: (state) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.user = null;
      state.error = null;
    },
    ClearErrors: (state) => {
      state.error = null;
    },
  },
});

// Export actions
export const {
  LoadUserRequest,
  LoadUserSuccess,
  LoadUserFail,
  LogoutUser,
  ClearErrors,
} = userSlice.actions;

// Export reducer
export default userSlice.reducer;
